import { logAudit } from "@/lib/audit";
import type { Database } from "@/integrations/supabase/types";

type AuditLogInsert = Database["public"]["Tables"]["audit_logs"]["Insert"];

interface RequestAuditParams {
  action: string;
  organizationId: string;
  recordId: string;
  /** Ignored: log_audit_event records auth.uid() as the actor, so a caller cannot name one. Kept so callers need no change. */
  userId?: string | null;
  oldData?: AuditLogInsert["old_data"];
  newData?: AuditLogInsert["new_data"];
}

// audit_logs has no INSERT policy for signed-in users, so a direct insert here was always refused and
// the entry silently lost (#7849). Write through log_audit_event, which authorizes the caller as a
// member of the organization and sets the actor itself. Best-effort, as before: logAudit reports a
// failure on the console and returns null rather than blocking the request action.
export async function logRequestAudit({
  action,
  organizationId,
  recordId,
  oldData,
  newData,
}: RequestAuditParams) {
  await logAudit({
    tableName: "requests",
    recordId,
    action,
    organizationId,
    oldData: (oldData ?? null) as Record<string, unknown> | null,
    newData: (newData ?? null) as Record<string, unknown> | null,
  });
}
